exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".leaderboard-upload .modal-outer.opened {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.leaderboard-upload .modal-content {\n    position: relative;\n}\n\n.leaderboard-upload .loader {\n    position: absolute;\n    top: 50%;\n    right: 50%;\n    transform: translate(-50%, -50%);\n    width: 30px;\n    height: 30px;\n}\n\n.leaderboard-upload .footer {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n}\n\n.leaderboard-upload .warning-message {\n    margin-top: 7px;\n}", ""]);

// exports
